import { render, staticRenderFns } from "./agentManage.vue?vue&type=template&id=039fdbc3&scoped=true&"
import script from "./agentManage.vue?vue&type=script&lang=js&"
export * from "./agentManage.vue?vue&type=script&lang=js&"
import style0 from "./agentManage.vue?vue&type=style&index=0&id=039fdbc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039fdbc3",
  null
  
)

export default component.exports